<script>
import Vue from "vue";
import { fetchData } from "@/api/oa";
import { redLineCheck } from "@/api/ssc";

import { formMap } from "@/assets/js/form";

import communication from "@/components/common/AxCommunication.vue";
import riskLevel from "@/components/common/AxRiskLevel.vue";

let d = new RegExp("&#39;", "g"),
  noticeHtml = `<div class="notice-box" v-if="!payFill">本次审批涉及到修改审批单内容，移动端暂时不支持该操作，请到360家-共享服务中心进行审批！</div>`,
  tipsHtml = `<div class="number">单号：{{bpmTask.billNo}}</div>`,
  communicationHtml = `<communication  :taskType="bpmTask.taskType" :instId="$route.query.instId"></communication>`,
  riskLevelHtml = `<risk-level  :list="approveHistory" ></risk-level>`,
  html = `<div v-if="payFill"><ax-panel :title="bpmTask.taskType === 'CMM'?'沟通意见':'审批意见'" :fold="false" :noBorder="true"><div><textarea  v-model="opinion" name="opinion"  class="comments_box" rows="5" :placeholder="bpmTask.taskType === 'CMM'?'请输入您的沟通意见':'请输入您的审批意见'"></textarea></div></ax-panel><div class="handle_box"><a href="javascript:;" v-for="(item,index) in btnList" :class="item.alias" @click="handleApproval(item)">{{item.name}}</a></div></div><suspend-button v-if="ownApprovalFlag" @click="recordJump">审批<br/>记录</suspend-button>`;

// 沟通回复模块
tipsHtml += communicationHtml;
tipsHtml += riskLevelHtml;

import {
  incomeValues,
  backfillValues,
  whetherOptions,
  whetherOptions1,
  vpOptions,
  expOptions,
  incomeOptions,
  freeOptions,
  investOptions,
  getValueByKey,
  selectJuryOptions,
  usaControlsItems,
  sUsaControlsItems,
  controlTypeOptions,
  usaRequireOptions,
  productAmericanOptions,
} from "@/assets/js/options";
import doNext from "@/mixins/doNext";

export default {
  name: "sscDetails",
  mixins: [doNext],
  components: {
    communication,
    riskLevel,
    finalSignfile: () => import("./FinalSignFile.vue"),
  },
  data() {
    return {
      selectJuryOptions,
      investOptions,
      incomeValues: incomeValues,
      backfillValues: backfillValues,
      whetherOptions: whetherOptions,
      whetherOptions1: whetherOptions1,
      vpOptions: vpOptions,
      usaControlsItems,
      sUsaControlsItems,
      controlTypeOptions,
      usaRequireOptions,
      productAmericanOptions,
      agreeOptions: [
        {
          label: "已经阅读表示同意",
          value: "Y",
        },
      ],
      agreeSpecialOptions: [
        {
          label: "已经阅读表示同意",
          value: "agree",
        },
      ],
      expOptions: expOptions,
      incomeOptions: incomeOptions,
      freeOptions: freeOptions,
      iotApplicationForm: {
        hint: "项目总费用可调整",
      },
      currentType: "approvalPending",
      action: true,
      template: null,
      urlTitle: "",
      payFill: true,
      taskId: this.$route.query.taskId,
      instId: this.$route.query.instId,
      version: this.$route.query.version || 0.0,
      budget: {},
      formKey: null,
      bpmTask: {},
      permission: {},
      startUser: {},
      data: {},
      modelData: {}, // 回填绑定数据时或者后端返回的数据中需要进行特殊转化时，modelData可以临时存储这些转化的数据，防止多余的变量提交到后端（比如直接用v-model双向绑定data中的值，而这个值在提交数据的时候需要转化，那么就需要modelData进行临时存储，防止提交转化的时候报错警告等未知风险）
      boDefId: null,
      btnList: [],
      approveHistory: [], // 风险等级列表
      opinion: "",
      whetherMap: new Map([
        ["1", "是"],
        ["0", "否"],
        ["Y", "已经阅读表示同意"],
        ["agree", "已经阅读表示同意"],
      ]),
      optionsMap: new Map([["1", "政府补贴"], ["2", "其他"]]),
      // radiosMap: new Map([
      //   ["1", "参加"],
      //   ["0", "不参加"]
      // ]),
      agreementList: [],
      toast: null,
      // 风险词库业务编号及名称映射
      riskWordBusinessMap: {
        MFM_1100000019631020: {
          name: "国拨类预算申请",
          key: "SSC-BUDGET-0011-SSC-BUDGET-国拨类预算申请",
          type: "BUDGET",
        },
        MFM_1200000003420182: {
          name: "收入流水申请",
          key: "SSC-REVENUE-0010-SSC-REVENUE-收入流水申请",
          type: "REVENUE",
        },
        MFM_2430000017855852: {
          name: "预提申请",
          key: "SSC-YT-0009-SSC-YT-预提申请",
          type: "YT",
        },
        MFM_2430000015606143: {
          name: "实际付款C单",
          key: "SSC-PAYMENT-0007-SSC-PAYMENT-实际付款C单",
          type: "PAYMENT",
        },
        MFM_243000001788167602: {
          name: "无预算付款申请",
          key: "SSC-PAYMENT-0006-SSC-PAYMENT-无预算付款申请",
          type: "PAYMENT",
        },
        MFM_2430000015604782: {
          name: "IOT付款申请",
          key: "SSC-PAYMENT-0005-SSC-PAYMENT-IOT付款申请",
          type: "PAYMENT",
        },
        MFM_1100000033372540: {
          name: "通用付款申请",
          key: "SSC-PAYMENT-0004-SSC-PAYMENT-通用付款申请",
          type: "PAYMENT",
        },
      },
    };
  },
  render: function(createElement) {
    if (!this.template) {
      return createElement("div", "");
    } else {
      return this.template();
    }
  },
  created() {
    this.toast = this.$toast.loading({
      mask: false,
      message: "加载中...",
      duration: 0,
    });
    this.getDetailsData();
    this.setApproveHistoryInfo();
  },
  watch: {
    "data.usa_controls_items_copy"() {
      // 物料申请单
      if (this.formKey == "MFM_1100000023210340") {
        if (
          ~this.data.usa_controls_items_copy.indexOf("NO") &&
          this.data.usa_controls_items_copy.length > 1
        ) {
          this.data.usa_controls_items_copy = ["NO"];
        }
      }
    },
    "data.product_American_copy"() {
      // 产品申请单
      if (this.formKey == "MFM_1100000023210297") {
        if (
          ~this.data.product_American_copy.indexOf("NO") &&
          this.data.product_American_copy.length > 1
        ) {
          this.data.product_American_copy = ["NO"];
        }
      }
    },
    instId() {
      this.setApproveHistoryInfo();
    },
    "$route.query.instId"() {
      this.setApproveHistoryInfo();
    },
  },
  updated() {
    this.setTitle();
  },
  methods: {
    // 申请类型整项匹配（防子串误判，如 hd 命中 yhdzd），供模板调用
    hasType(val, key) {
      if (!val) return false;
      const keys = typeof val === "string" ? val.split(",") : val;
      return keys.indexOf(key) !== -1;
    },
    isJSON(str) {
      if (typeof str === "string") {
        try {
          var obj = JSON.parse(str);
          return true;
        } catch (e) {
          return false;
        }
      } else {
        return false;
      }
    },
    downLoadFile(fileId) {
      iqh.preViewFile({
        fileId: fileId,
      });
    },
    setTitle() {
      this.$setIosTitle(this.urlTitle);
    },
    // 设置审批记录的url
    setApproveHistoryInfo() {
      let url = `${location.origin}/ssc/record/details?instId=${
        this.$route.query.instId
      }&appid=${this.$route.query.appid}&version=${this.$route.query.version}`;
      // console.log(url)
      iqh.updateApproveInfo &&
        iqh.updateApproveInfo({
          // "redirectURL": url,
          rightTextClickURL: url,
        });
    },
    //  根据某个单子进行提示
    showTips(formKey, name) {
      let msg = "";
      // 全员邮件
      if (formKey == "MFM_2400000015301062" && name == "当天发送确认") {
        msg =
          "1、点击确认后流程即结束，代表该封allstaff允许被放行；\n" +
          "2、放行时间：工作日09:30-19:00，流程结束后2个工作小时内完成放行；\n" +
          "3、特殊需要指定放行时间的，请提前致电010-58781234沟通后，再点击确认通过流程.";
      }
      if (!msg) return;
      this.$dialog.alert({
        title: "提示",
        message: msg,
        messageAlign: "left",
      });
    },
    setPayFill(formKey, name) {
      console.log(formKey, name, "formKeyformKey");
      const bpmTaskArr = [
        "发起人上传扫描件",
        "合同定稿",
        "合同盖章",
        "合同领取",
        "合同归档",
        "电子盖章（我方先章）",
        "电子盖章（他方先章）",
        "外部签署",
        "境外执行组",
        "(境内)法务公章/资质借出执行组",
        "(境外)法务公章/资质借出执行组",
        "(境内)法务公章/资质归还执行组",
        "(境外)法务公章/资质归还执行组",
        // 合同相关  1.支出合同 2. 收入合同 3. 免费合同申请单  以及相关协议   1.通用付款 2. 无预算付款
        "财务初审（子公司）",
        "财务复审（子公司）",
        "法务（子公司）",
      ];
      if (bpmTaskArr.includes(name)) {
        this.payFill = false;
        return;
      }

      if (
        name === "法务公章及资质执行组" &&
        formKey !== "MFM_1100000029261543"
      ) {
        this.payFill = false;
        return;
      }

      if (name === "法务审核组") {
        const keyArr = [
          "MFM_2430000015602217",
          "MFM_110000002618101602",
          "MFM_1100000026181016",
          "MFM_110000002618101603",
          "MFM_110000002882205902",
          "MFM_110000002882205903",
          "MFM_1100000028822059",
          "MFM_243000001743175505",
          "MFM_2430000017481364",
          "MFM_2430000015601786",
        ];
        if (keyArr.includes(formKey)) {
          this.payFill = false;
          return;
        }
      }

      // 外包人员申请单新
      if (name === "人工处理" && formKey === "MFM_2430000027871009") {
        this.payFill = false;
        return;
      }
      // 投后事项 申请单
      // if(formKey === 'MFM_1100000000740001' && name === '投后负责人'){
      //   this.payFill = false;
      // }
      if (
        (formKey === "MFM_1100000033372540" ||
          formKey === "MFM_243000001788167602" ||
          formKey === "MFM_2430000015604782" ||
          formKey === "MFM_1100000039016543") &&
        ~name.indexOf("财务初审")
      ) {
        this.payFill = false;
        return;
      }
      // 财务资金类资质/文件申请单：资质执行组、资金执行组不开放移动端审批
      if (
        formKey === "MFM_1100000039016543" &&
        (~name.indexOf("资质执行组") || ~name.indexOf("资金执行组"))
      ) {
        this.payFill = false;
        return;
      }
      // 付款申请单
      let PaymentNodeList = ["财务负责人前置审批", "集团财务负责人", "CEO"];
      if (
        formKey === "MFM_2430000015606143" &&
        !PaymentNodeList.includes(name)
      ) {
        this.payFill = false;
        return;
      }

      if (
        formKey === "MFM_1100000000740001" &&
        (name === "法务初审" || name === "财务初审" || name === "法务归档")
      ) {
        this.payFill = false;
        return;
      }
      // 判断税务
      if (formKey === "MFM_1300000000230694" && name === "税务审核") {
        this.payFill = false;
        return;
      }
      if (
        formKey === "MFM_1200000000220820" &&
        name === "合同管理员（沟通领取）"
      ) {
        this.payFill = false;
        return;
      }

      // 公章使用/借出申请单
      if (formKey === "MFM_4760000020242478") {
        const keyArr = [
          "借出归还组",
          "借出执行组",
          "归还执行组",
          "执照执行组",
          "资质类执行组",
          "商标执行组",
          "周总证件",
          "知识产权类",
          "文件执行组",
          "资金执行组",
          "盖章执行组",
          "HR运营审批",
          "社保审批组",
        ];
        keyArr.forEach((item) => {
          if (~name.indexOf(item)) {
            this.payFill = false;
            return;
          }
        });
        if (!this.payFill) {
          return;
        }
      }

      //  资产配给组 更改为 资产备货 ----
      if (
        formKey === "MFM_1200000000323061" &&
        (name === "资产备货" ||
          name === "资产配给组" ||
          name === "资产经理" ||
          name === "资产发放组")
      ) {
        this.payFill = false;
        return;
      }
      if (formKey === "MFM_1200000000361770" && name === "工卡办理操作组") {
        this.payFill = false;
        return;
      }
      if (formKey === "MFM_1100000016127097" && name !== "直属M级") {
        this.payFill = false;
        return;
      }
      //  资产配给组 更改为 资产备货 ----
      if (
        formKey === "MFM_1100000015651327" &&
        (name === "资产备货" ||
          name === "资产配给组" ||
          name === "采购组" ||
          name === "资产发放组")
      ) {
        this.payFill = false;
        return;
      }
      if (
        formKey === "MFM_1100000017290286" &&
        (name === "采购组" ||
          name === "固资丢失赔偿财务组" ||
          name === "固定资产管理员组")
      ) {
        this.payFill = false;
        return;
      }
      if (formKey === "MFM_1100000020170072" && name === "SQA发布审批组") {
        this.payFill = false;
        return;
      }
      if (formKey === "MFM_1100000024350007" && name === "指定测试人员") {
        this.payFill = false;
        return;
      }
      if (
        formKey === "MFM_1100000024110005" &&
        (name === "领用制作人" || name === "业务经分")
      ) {
        this.payFill = false;
        return;
      }
      if (formKey === "MFM_1100000027600030" && name === "资产财务") {
        this.payFill = false;
        return;
      }
      if (
        formKey === "MFM_1100000028820195" &&
        (name === "发起人(回填业务)" || name === "轮值班长(回填CEO审批)")
      ) {
        this.payFill = false;
        return;
      }
      // IOT价格政策审批
      if (
        formKey === "MFM_1100000000280460" &&
        /^销售管理部[((]?价格同步/.test(name)
      ) {
        this.payFill = false;
        return;
      }
      // 资产归还 最后一个节点去 pc端审批
      if (
        formKey === "MFM_1200000000292294" &&
        (name === "资产管理员审核确认" || name === "资产入库/确认")
      ) {
        this.payFill = false;
        return;
      }
      // 公众号申请 只有上级领导可以审批
      if (formKey === "MFM_2480000002680071" && name !== "上级领导审批") {
        this.payFill = false;
        return;
      }
      // 专利申请单
      if (formKey === "MFM_1200000002190173" && name == "专利工程师") {
        this.payFill = false;
        return;
      }
      // 费用预提申请 仅开放财务复审节点移动端审批
      if (
        formKey === "MFM_2430000017855852" &&
        (name == "财务初审" || name == "财务初审CMM")
      ) {
        // MFM_2430000017855852（手机表单标识类型）
        this.payFill = false;
        return;
      }
    },

    // btnList 接口写死的，同意 和 驳回
    // 不能驳回 只能同意
    setBtnList(formKey, name) {
      // 合同相关  1.支出合同 2. 收入合同 3. 免费合同申请单  以及相关协议   1.通用付款 2. 无预算付款
      if (
        this.bpmTask.name === "COO（子公司）" ||
        this.bpmTask.name === "财务（子公司）"
      ) {
        let bItem = this.btnList.find((bbItem) => bbItem.alias === "approve");
        if (bItem) {
          this.btnList = [bItem];
        }
      }
    },
    getAgreement(id) {
      fetchData("getAgreements", {
        sourceId: id,
      })
        .then((response) => {
          this.agreementList = response.data;
        })
        .catch(() => {
          this.toast.clear();
        });
    },
    //  根据后端请求 处理数据
    modifyFn() {
      // BCM 流程 物料申请单
      if (this.formKey == "MFM_1100000023210340") {
        this.$set(this.data, "usa_controls_items_copy", []);
        if (
          this.data.material_type == "HARD" &&
          typeof this.data.usa_controls_items == "string"
        ) {
          this.data.usa_controls_items_copy = this.data.usa_controls_items.split(
            ","
          );
        }
        if (
          this.data.material_type == "SOFT" &&
          typeof this.data.usa_controls_soft == "string"
        ) {
          this.data.usa_controls_items_copy = this.data.usa_controls_soft.split(
            ","
          );
        }
        // 软件
        if (
          this.data.material_type == "SOFT" &&
          !this.data.usa_controls_soft &&
          this.data.not_checked_soft == "NOCHECKED"
        ) {
          this.data.usa_controls_items_copy = ["NO"];
        }
        // 硬件
        if (
          this.data.material_type == "HARD" &&
          !this.data.usa_controls_items &&
          this.data.not_checked == "NOCHECKED"
        ) {
          this.data.usa_controls_items_copy = ["NO"];
        }
      }

      // BCM 流程 产品申请单
      if (this.formKey == "MFM_1100000023210297") {
        this.$set(this.data, "product_American_copy", []);
        if (typeof this.data.product_American == "string") {
          // this.$set(this.data, 'product_American_copy', this.data.product_American.split(','))
          this.data.product_American_copy = this.data.product_American.split(
            ","
          );
        }
        if (
          !this.data.product_American &&
          this.data.not_all_checked == "NOCHECKED"
        ) {
          // this.$set(this.data, 'product_American_copy', ['NO']);
          this.data.product_American_copy = ["NO"];
        }
      }
      // 电子公章、（资质/文件用章、资质/文件/章类借出借用）
      if (
        this.formKey == "MFM_1100000029261543" ||
        this.formKey == "MFM_4760000020242478"
      ) {
        if (this.permission.approve_choose_form === "w") {
          const approveChoose = this.data.approve_choose
            ? this.data.approve_choose.split(",")
            : [];
          this.$set(this.modelData, "approve_choose", approveChoose);
          this.$set(this.modelData, "none_approve", !!this.data.none_approve);
        }
      }
      // 资质/文件/章类借出借用
      if (this.formKey == "MFM_4760000020242478") {
        const secondClassif = this.data.second_classif
          ? this.data.second_classif.split(",")
          : [];
        this.modelData["isShowLicenseUse"] = secondClassif.some((type) => {
          return type == "1010" || type == "1020";
        });
      }
    },

    /* 沟通任务的处理
     ** 1. permission 全部只读， 不准审批
     ** 2. 根据节点名称审批的， 节点名称后面 + CMM
     */
    doCommunicate() {
      // 沟通任务
      if (this.bpmTask.taskType === "CMM") {
        for (let key in this.permission) {
          this.permission[key] = "r"; // 全部改为只读
        }
        this.bpmTask.name += "CMM";
        this.action = false;
      }
    },

    //  请求数据
    getDetailsData() {
      fetchData("getUpComingDetails", this.taskId)
        .then((response) => {
          this.toast.clear();
          if (response.data.success === true) {
            if (
              response.data.data === "taskEnd" ||
              response.data.data.formModels === "noForm"
            ) {
              this.template = Vue.compile(
                '<section class="approval-end-tips">当前数据已审批完成</section>'
              ).render;
              return;
            }
            this.permission = JSON.parse(
              response.data.data.formModels[0].permission
            );
            this.formKey = response.data.data.formModels[0].formKey;
            this.bpmTask = response.data.data.bpmTask;
            this.data = response.data.data.formModels[0].jsonData;
            this.boDefId = response.data.data.formModels[0].boDefId;
            this.startUser = response.data.data.startUser;
            this.approveHistory =
              response.data.data.approveHistory &&
              response.data.data.approveHistory.filter(
                (item) => !!item.labelName
              );
            this.btnList = response.data.data.taskConfig.buttons.reverse();

            /* 沟通任务的处理
             ** 1. permission 全部只读， 不准审批
             ** 2. 根据节点名称审批的， 节点名称后面 + 5555
             */
            // this.bpmTask.taskType = "CMM";
            this.doCommunicate();

            // 单个表单的数据处理

            this.modifyFn();

            // 结算收入流程单 数据需要分类计算 单独处理
            if (
              this.formKey === "MFM_1200000003420182" ||
              this.formKey === "MFM_2490000001719369"
            ) {
              this.modifyData();
            }
            // 云盘扩容   target_space num to string
            if (this.formKey === "MFM_1200000001680042") {
              this.data.target_space += "";
            }
            // 设置title
            if (this.formKey === "MFM_4760000020242478") {
              // 设置title
              this.data.category === "0"
                ? (this.urlTitle = "资质/文件用章申请单")
                : (this.urlTitle = "资质/文件/章类借出借用申请单");
            } else if (this.formKey === "MFM_1100000039016543") {
              // 财务资金类资质/文件申请单：标题不依赖后端 description
              this.urlTitle = "财务资金类资质/文件申请单";
            } else if (this.formKey === "MFM_1100000013580007") {
              this.urlTitle = this.data.pay_type_name + "申请单";
            } else {
              this.urlTitle = response.data.data.formModels[0].description;
            }

            // 移动端无法审批节点
            this.setPayFill(this.formKey, this.bpmTask.name);
            this.setBtnList(this.formKey, this.bpmTask.name);
            // 根据某个单子进行提示
            this.showTips(this.formKey, this.bpmTask.name);

            // 相关协议
            if (
              this.formKey === "MFM_110000002618101602" ||
              this.formKey === "MFM_1100000026181016" ||
              this.formKey === "MFM_110000002618101603" ||
              this.formKey === "MFM_243000001743175505" ||
              this.formKey === "MFM_2430000015602217"
            ) {
              this.getAgreement(this.data.ID_);
            }

            if (
              this.formKey === "MFM_1100000019631020" &&
              this.data.is_append !== "0"
            ) {
              fetchData("overallBudget", {
                sourceCode: this.data.source_code,
                totalBudget: this.data.total_budget,
                instId: this.instId,
              }).then((response) => {
                if (response.data.success) {
                  this.budget = response.data.data;
                }
              });
            }

            // 法务回填设置值
            if (this.permission.tags_form === "w") {
              if (this.data.tags) {
                this.data.tags = this.data.tags.split(",");
              } else {
                this.$set(this.data, "tags", []);
              }
            }

            // 外部人员账号申请单 回填的部分
            if (
              this.permission.domain_name_form === "w" &&
              this.data.SUB_outsourcer_account_item
            ) {
              this.data.SUB_outsourcer_account_item.forEach((item, index) => {
                item.outsourcer_domain = item.outsourcer_domain
                  ? item.outsourcer_domain
                  : "v-" + item.outsourcer_pinyin;
              });
            }

            // 全员邮件直属M级别回填
            if (
              this.permission.declare_form === "w" &&
              (this.formKey === "m_allstaff_mail" ||
                this.formKey === "MFM_2400000015301062")
            ) {
              this.data.declare = undefined;
              this.data.declare_name = undefined;
            }

            if (formMap.get(this.formKey)) {
              this.template = Vue.compile(
                "<section class='approved_box'>" +
                  noticeHtml +
                  tipsHtml +
                  formMap.get(this.formKey).replace(d, "'") +
                  html +
                  "</section>"
              ).render;
            } else {
              this.template = Vue.compile(
                "<section class='approved_box'>" +
                  noticeHtml +
                  tipsHtml +
                  response.data.data.formModels[0].content.replace(d, "'") +
                  html +
                  "</section>"
              ).render;
            }
            // this.template = Vue.compile("<section class='approved_box'>"+ tipsHtml + response.data.data.formModels[0].content.replace(d, "'") + html +"</section>").render;
          } else {
            this.template = Vue.compile(
              '<section><result type="network" subtext="要不然下拉刷新试试？"></result></section>'
            ).render;
          }
        })
        .catch((e) => {
          this.toast.clear();
          this.template = Vue.compile(
            '<section><result type="network" subtext="要不然下拉刷新试试？"></result></section>'
          ).render;
        });
    },

    // 结算收入流程
    modifyData() {
      let obj = {
        change: "变更",
        new: "新建",
        edit: "修改",
        invalid: "作废",
      };
      this.data.category_name = obj[this.data.category];
      let SUB_sm_flow_lines =
        this.data.SUB_sm_flow_lines || this.data.SUB_sm_flow_reduce_lines;
      this.data.itemslength = SUB_sm_flow_lines.length;
      SUB_sm_flow_lines = SUB_sm_flow_lines.sort((a, b) => {
        a.amount - b.amount;
      });
      let SUB_sm_flow_items = SUB_sm_flow_lines.slice(0, 5);
      // 按照币种分类 并计算总额
      let SUB_sm_flow_currencys = [];
      //其他的大于5的金额合计计算
      let SUB_sm_flow_lines5 = [];

      // 减值结算流水单
      let total_amount = 0; // 减值金额
      let total_currency_amount = 0; // 原币币种合计金额
      SUB_sm_flow_lines.forEach((item, index) => {
        total_amount += item.reduce;
        total_currency_amount += item.amount;
        let idx = SUB_sm_flow_currencys.findIndex(
          (dd) => dd.currency === item.currency
        );
        if (~idx) {
          SUB_sm_flow_currencys[idx].amount += item.amount;
        } else {
          SUB_sm_flow_currencys.push({
            currency: item.currency,
            currency_name: item.currency_name,
            amount: item.amount,
            reduce: item.reduce,
          });
        }
        //从第5个开始计算
        if (index > 4) {
          let idx5 = SUB_sm_flow_lines5.findIndex(
            (dd) => dd.currency === item.currency
          );
          if (~idx5) {
            SUB_sm_flow_lines5[idx].amount += item.amount;
            SUB_sm_flow_lines5[idx].ar += item.ar;
            SUB_sm_flow_lines5[idx].reduce += item.reduce;
            SUB_sm_flow_lines5[idx].vendor_a_ap += item.vendor_a_ap;
          } else {
            SUB_sm_flow_lines5.push({
              currency: item.currency,
              currency_name: item.currency_name,
              amount: item.amount,
              ar: item.ar,
              vendor_a_ap: item.vendor_a_ap,
              reduce: item.reduce,
            });
          }
        }
      });
      this.data.SUB_sm_flow_items = SUB_sm_flow_items.concat(
        SUB_sm_flow_lines5
      );
      this.data.SUB_sm_flow_currencys = SUB_sm_flow_currencys;
      this.data.total_amount = total_amount;
      this.data.total_currency_amount = total_currency_amount;
    },

    // 根据页面 form  处理成后端需要的格式
    changeToServerData() {
      // 物料申请单
      if (
        this.formKey == "MFM_1100000023210340" &&
        this.data.usa_controls_items_copy
      ) {
        let usa_controls_items_copy = this.data.usa_controls_items_copy.slice(
          0
        );
        let index = usa_controls_items_copy.findIndex((item) => item == "NO");
        index > -1 && usa_controls_items_copy.splice(index, 1);
        if (this.data.material_type == "SOFT") {
          this.data.usa_controls_soft = usa_controls_items_copy.join(",");
          this.data.not_checked_soft = this.data.usa_controls_soft
            ? ""
            : "NOCHECKED";
          this.data.not_checked_soft_name = this.data.usa_controls_soft
            ? ""
            : "以上选项皆不选";
        } else {
          this.data.usa_controls_items = usa_controls_items_copy.join(",");
          // 设置以上皆不选
          this.data.not_checked = this.data.usa_controls_items
            ? ""
            : "NOCHECKED";
          this.data.not_checked_name = this.data.usa_controls_items
            ? ""
            : "以上选项皆不选";
        }
      }
      // BCM 流程 产品申请单
      if (
        this.formKey == "MFM_1100000023210297" &&
        this.data.product_American_copy
      ) {
        let product_American_copy = this.data.product_American_copy.slice(0);
        let index = product_American_copy.findIndex((item) => item == "NO");
        index > -1 && product_American_copy.splice(index, 1);
        this.data.product_American = product_American_copy.join(",");
        this.data.not_all_checked = this.data.product_American
          ? ""
          : "NOCHECKED";
        this.data.not_all_checked_name = this.data.product_American
          ? ""
          : "以上选项皆不选";
      }

      // 电子公章、（资质/文件用章、资质/文件/章类借出借用）
      if (
        this.formKey == "MFM_1100000029261543" ||
        this.formKey == "MFM_4760000020242478"
      ) {
        if (this.permission.approve_choose_form === "w") {
          this.data["approve_choose"] = this.modelData.approve_choose.join(",");
          this.data["approve_choose_name"] = "";
          this.data["none_approve"] = this.modelData.none_approve ? "none" : "";
          this.data["none_approve_name"] = "";
        }
      }
    },

    // 沟通
    handleCommunicate(item) {
      // 点击取消的话
      if (item.alias === "cancel") {
        this.$dialog
          .confirm({
            title: "提示",
            message: "确定取消并回退吗？您输入的内容将不会被保存！",
            beforeClose: (action, done) => {
              if (action === "confirm") {
                this.$router.go(-1);
                done();
              } else {
                done();
              }
            },
          })
          .catch(() => {});
        return;
      }
      let prompt = "确定执行沟通任务？";
      if (this.opinion === "") {
        this.toast.clear();
        this.toast = this.$toast({
          message: "请您输入沟通内容",
          duration: 1500,
        });
        return;
      }

      // 对沟通内容进行校验
      let emojiRegExp = /(?:[\u2600-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDEFF]|\uD83E[\uDC00-\uDDFF]|\uD83F[\uDC00-\uDFFF]|[\u200D\u200C\uFE0F\uFEFF]|[\u2300-\u23FF]|[\u2B00-\u2BFF]|[\u25A0-\u25FF]|[\u2500-\u257F]|[\u2190-\u21FF])/g;

      if (emojiRegExp.test(this.opinion)) {
        this.toast = this.$toast({
          message: "沟通内容不允许录入表情符号",
          duration: 1500,
        });
        return;
      }

      let data = {
        taskId: this.taskId,
        jumpType: item.alias,
        opinion: this.opinion.replace(
          "/uD83C|uD83D|uD83E[u200D|uFE0F]|uD83C|uD83D|uD83E|[0-9|*|#]uFE0Fu20E3|[0-9|#]u20E3|[u203C-u3299]uFE0Fu200D|[u203C-u3299]uFE0F|[u2122-u2B55]|u303D|[A9|AE]u3030|uA9|uAE|u3030/ig",
          ""
        ),
      };
      // data.jsonData = JSON.stringify(this.data);
      // console.log(data)
      this.$dialog
        .confirm({
          title: "提示",
          message: prompt,
          beforeClose: (action, done) => {
            if (action === "confirm") {
              this.handleDoNext(data, "沟通回复成功", done);
            } else {
              done();
            }
          },
        })
        .catch(() => {});
    },

    // 审核
    async handleApproval(item) {
      // 法务公章及资质执行组节点判断是否生成正章文件
      if (
        this.bpmTask.name === "法务公章及资质执行组" &&
        this.formKey === "MFM_1100000029261543"
      ) {
        const signFile = this.$refs.finalSignFile.getSignFile();
        if (item.alias === "approve" && !signFile) {
          this.$toast({
            message: "需盖章文件未生成正章文件，请确认生成",
            duration: 3000,
          });
          return;
        }
        if (signFile) {
          this.data.final_sign_file = signFile;
        }
      }
      // 沟通
      if (this.bpmTask.taskType == "CMM") {
        this.handleCommunicate(item);
        return;
      }
      this.changeToServerData();
      let data = {},
        prompt = "",
        query = {
          bos: [],
        };

      // 设置回填项中文字段
      let keyArr = [
        "our_standard_template",
        "is_important_fin",
        "is_important_securities",
        "is_important_law",
        "is_major",
        "need_purchase",
        "is_vp_approve",
      ];
      // let radiosArr = ["situation"];
      let selectArr = ["income_type"];

      let formKeyArr = [
        {
          key: "is_important_invest",
          list: investOptions,
        },
        {
          key: "review_committee_opinion_type",
          list: selectJuryOptions,
        },
        {
          key: "product_American",
          list: productAmericanOptions,
          mutiple: 1,
        },
        {
          key: "control_type",
          list: controlTypeOptions,
        },
        {
          key: "usa_exit_require",
          list: usaRequireOptions,
        },
        {
          key: "usa_controls_items",
          list: usaControlsItems,
          mutiple: 1,
        },
        {
          key: "usa_controls_soft",
          list: sUsaControlsItems,
          mutiple: 1,
        },
        {
          key: "is_free",
          list: whetherOptions,
        },
        {
          key: "is_public_anonymity_access",
          list: whetherOptions,
        },
        {
          key: "is_control",
          list: whetherOptions,
        },
      ];

      formKeyArr.forEach((item, index) => {
        if (this.permission[item.key + "_form"] === "w") {
          this.data[item.key + "_name"] = getValueByKey(
            this.data[item.key],
            item.list,
            item.mutiple
          );
        }
      });

      keyArr.forEach((item, index) => {
        if (this.permission[item + "_form"] === "w") {
          this.data[item + "_name"] = this.whetherMap.get(this.data[item]);
        }
      });

      selectArr.forEach((item, index) => {
        if (this.permission[item + "_form"] === "w") {
          this.data[item + "_name"] = this.optionsMap.get(this.data[item]);
        }
      });

      // console.log(this.data);

      // radiosArr.forEach((item, index) => {
      //   if (this.permission[item + "_form"] === "w") {
      //     this.data[item + "_name"] = this.radiosMap.get(this.data[item]);
      //   }
      // });

      // if (this.version <= 1.0) {
      //   this.checkVersion();
      //   return;
      // }

      // 敏感词校验
      // 表单存在于红线校验列表里
      try {
        if (
          this.riskWordBusinessMap[this.formKey] &&
          item.alias === "approve"
        ) {
          let redLineFlag = false;
          const curBusiness = this.riskWordBusinessMap[this.formKey];
          const data = JSON.stringify(this.data);
          // 校验表单是否触碰红线
          let res = await redLineCheck({
            businessNumberName: curBusiness.key,
            businessType: curBusiness.type,
            businessName: curBusiness.name,
            sourceNumber: this.bpmTask.billNo,
            data,
          });
          if (res.data.data.Block && res.data.data.Block != "[]") {
            this.$dialog.alert({
              message: `表单${
                res.data.data.Block
              }字段填写不符合规范，请重新填写。【如有疑问，请联系财务初审】`,
            });
            redLineFlag = true;
          } else if (res.data.data.Warn && res.data.data.Warn != "[]") {
            await new Promise((resolve, reject) => {
              this.$dialog
                .confirm({
                  message: `表单${
                    res.data.data.Warn
                  }字段填写不符合规范，是否确认提交？【如有疑问，请联系财务初审】`,
                })
                .catch(() => {
                  redLineFlag = true;
                })
                .finally(() => {
                  resolve();
                });
            });
          }
          if (redLineFlag) {
            return;
          }
        }
      } catch (err) {
        console.log(err);
      }

      if (item.alias === "approve") {
        prompt = "确认执行同意操作";
        query.bos.push({
          boDefId: this.boDefId,
          formKey: this.formKey,
          readOnly: false,
          data: this.data,
        });

        // 对审批意见进行校验
        let emojiRegExp = /(?:[\u2600-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDEFF]|\uD83E[\uDC00-\uDDFF]|\uD83F[\uDC00-\uDFFF]|[\u200D\u200C\uFE0F\uFEFF]|[\u2300-\u23FF]|[\u2B00-\u2BFF]|[\u25A0-\u25FF]|[\u2500-\u257F]|[\u2190-\u21FF])/g;

        if (emojiRegExp.test(this.opinion)) {
          this.toast = this.$toast({
            message: "审批意见不允许录入表情符号",
            duration: 1500,
          });
          return;
        }
        this.opinion = this.opinion || "同意";
        data = {
          taskId: this.taskId,
          jumpType: item.alias,
          opinion: this.opinion.replace(
            "/uD83C|uD83D|uD83E[u200D|uFE0F]|uD83C|uD83D|uD83E|[0-9|*|#]uFE0Fu20E3|[0-9|#]u20E3|[u203C-u3299]uFE0Fu200D|[u203C-u3299]uFE0F|[u2122-u2B55]|u303D|[A9|AE]u3030|uA9|uAE|u3030/ig",
            ""
          ),
          // 这个给的就是渲染的全部的值
          jsonData: JSON.stringify(query),
        };
      } else {
        prompt =
          item.alias == "reject"
            ? "本流程将驳回至发起人重走流程，确认驳回？如需其他操作，请移至PC端"
            : "拒绝后流程将作废，发起人不可再次提交，是否确认拒绝?";
        if (this.opinion === "") {
          this.toast.clear();
          this.toast = this.$toast({
            message: "请您输入审批意见",
            duration: 1500,
          });
          return;
        }

        // 对审批意见进行校验
        let emojiRegExp = /(?:[\u2600-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDEFF]|\uD83E[\uDC00-\uDDFF]|\uD83F[\uDC00-\uDFFF]|[\u200D\u200C\uFE0F\uFEFF]|[\u2300-\u23FF]|[\u2B00-\u2BFF]|[\u25A0-\u25FF]|[\u2500-\u257F]|[\u2190-\u21FF])/g;

        if (emojiRegExp.test(this.opinion)) {
          this.toast = this.$toast({
            message: "审批意见不允许录入表情符号",
            duration: 1500,
          });
          return;
        }
        data = {
          taskId: this.taskId,
          jumpType: item.alias,
          opinion: this.opinion.replace(
            "/uD83C|uD83D|uD83E[u200D|uFE0F]|uD83C|uD83D|uD83E|[0-9|*|#]uFE0Fu20E3|[0-9|#]u20E3|[u203C-u3299]uFE0Fu200D|[u203C-u3299]uFE0F|[u2122-u2B55]|u303D|[A9|AE]u3030|uA9|uAE|u3030/ig",
            ""
          ),
        };
        data.jsonData = JSON.stringify(this.data);
      }
      // if (process && process.env && process.env.NODE_ENV == "development") {
      //      console.log(this.data);
      //     // console.log(data.jsonData);
      // }

      // 驳回的时候不需要验证 直接驳回
      if (item.alias == "reject") {
        this.rejectFn(prompt, data);
        return;
      }
      if (item.alias == "BACK_TO_END") {
        this.doRejectToDialog(data, prompt);
        return;
      }
      // 审核通过的时候经过验证
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$dialog
            .confirm({
              title: "提示",
              message: prompt,
              beforeClose: (action, done) => {
                if (action === "confirm") {
                  this.handleDoNext(data, "审批成功", done);
                } else {
                  done();
                }
              },
            })
            .catch(() => {});
          return;
        }
        this.toast = this.$toast({
          duration: 1500,
          message: "请完成回填项",
          icon: "warn-o",
        });
      });
    },
    // 驳回逻辑
    // 增加点击驳回之后的逻辑修改， 不影响之前 是否显示 驳回按钮的需求
    // SSC-3086
    // 移动端驳回可选择驳回的方式：1.驳回至发起人 2.驳回到上一个节点
    // 选择驳回至发起人后进一步选择： 1.提交后到本节点 2. 提交后重新走流程
    // 弹框组件不能传本身数据参数， 所以必须确保点击确定的时候是哪个 驳回流程
    // 目前的做法： 如果存在 驳回至发起人，则一定在确认按钮的位置， action == confirm;
    rejectFn(prompt, data) {
      let rejectBtnList = this.btnList.find((item) => item.alias == "reject");
      if (!rejectBtnList) {
        this.doRejectToDialog(data, prompt);
        return;
      }
      let childrenList = rejectBtnList.children || [];
      //   childrenList.unshift({name: 'kkk', alias: 'kkk'});
      let childrenListObj = {},
        cChildrenListObj = {};
      if (!childrenList.length) return;
      let childrenIndex = childrenList.findIndex(
        (item) => item.alias == "BACK_TO_STARTOR"
      );
      // 驳回到发起人
      // 如果存在 则正常返回 如果没有那就直接写 驳回上一个节点
      childrenListObj.backtostartor =
        childrenIndex > -1 ? childrenList[childrenIndex] : {};
      // 返回到上一个节点
      childrenListObj.backtoup =
        childrenIndex > -1
          ? childrenList[Math.abs(childrenIndex - 1)] || {}
          : childrenList[0];
      // 节点选择
      let cChildrenList =
        childrenIndex > -1 && childrenList[childrenIndex].children
          ? childrenList[childrenIndex].children
          : [];
      //    cChildrenList[1] = {name: 'kkk', alias: 'kkk'};
      //   if (!cChildrenList.length) {
      //     return;
      //   }
      let options = {
        title: "选择驳回方式",
        className: "children-list",
        cancelButtonColor: "#3873fa",
        cancelButtonText: childrenListObj.backtoup.name,
        showCancelButton:
          childrenListObj.backtostartor.name && childrenListObj.backtoup.name,
        confirmButtonText:
          childrenListObj.backtostartor.name || childrenListObj.backtoup.name,
      };
      let cOptions = {
        title: "选择驳回后提交后的节点",
        className: "children-list",
        cancelButtonColor: "#3873fa",
        cancelButtonText: cChildrenList[1] ? cChildrenList[1].name : "取消",
        showCancelButton: !!cChildrenList[1],
        confirmButtonText: cChildrenList[0] ? cChildrenList[0].name : "",
      };

      this.$dialog
        .confirm({
          ...options,
          beforeClose: (action, done) => {
            // 点击确认
            if (action === "confirm") {
              if (childrenListObj.backtostartor.name) {
                // 打开另一个弹框
                data.jumpType = childrenListObj.backtostartor.alias;
                this.rejectSelectAfterSubmit(
                  data,
                  cOptions,
                  cChildrenList,
                  done
                );
              } else {
                // 直接去审批
                data.jumpType = childrenListObj.backtoup.alias;
                this.doRejectToServer(data, done);
              }
            } else {
              // 点击取消
              // 直接去审批
              data.jumpType = childrenListObj.backtoup
                ? childrenListObj.backtoup.alias
                : data.jumpType;
              this.doRejectToServer(data, done);
            }
          },
        })
        .catch(() => {});
      return;
    },
    // 选择驳回至发起人后进一步选择： 节点选择 1. 提交后到本节点， 2. 提交后重走流程
    rejectSelectAfterSubmit(data, cOptions, cChildrenList, done) {
      if (!cChildrenList.length) {
        // 直接去审批
        this.doRejectToServer(data, done);
        return;
      }
      done(); // 关闭上一个弹窗
      // 延迟的目的是为了解决连续两个弹窗无间隔的时候会出现没有遮罩层的问题
      setTimeout(() => {
        this.$dialog
          .confirm({
            ...cOptions,
            beforeClose: (action, done) => {
              // 点击确认
              if (action === "confirm") {
                data.nextJumpType = cChildrenList[0].alias;
              } else {
                // 点击取消
                data.nextJumpType = cChildrenList[1].alias;
              }
              // 直接去审批
              this.doRejectToServer(data, done);
            },
          })
          .catch(() => {});
      }, 600);
    },
    // 审批驳回和拒绝 带弹框询问的
    doRejectToDialog(data, prompt) {
      this.$dialog
        .confirm({
          title: "提示",
          message: prompt,
          beforeClose: (action, done) => {
            if (action === "confirm") {
              this.doRejectToServer(data, done);
            } else {
              done();
            }
          },
        })
        .catch(() => {});
    },
    // 执行审批拒绝
    doRejectToServer(data, done) {
      this.handleDoNext(data, "审批成功", done);
    },
    // 跳转到审批记录
    recordJump() {
      const { instId, appid } = this.$route.query;
      this.$router.push({
        path: "/ssc/record/details",
        query: {
          instId,
          appid,
        },
      });
    },
  },
  beforeDestroy() {
    this.toast.clear();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.ssc-tips {
  color: #f7a75b;
  font-size: 12px;
  line-height: 1.5;
}

.notice-box {
  color: #000;
  opacity: 0.5;
  font-size: 14px;
  line-height: 20px;
  padding: 7px 16px;
  background-color: $bg-color;
}

.comments_box.errors_box::placeholder {
  color: #f44;
}
</style>
